module.exports = __webpack_public_path__ + "img/bulls-eye.493d566e.svg";